import type { TExperienceMode } from "@lexicanon/shared"
import { Trans } from "@lingui/react/macro"
import { Menu } from "@mantine/core"
import { IconAdjustments, IconCheck } from "@tabler/icons-react"
import type { IProps } from "./interfaces"

import classes from "./styles.module.css"

/**
 * Dumb view for ExperienceModeMenu. Renders a nested Menu.Sub so it slots
 * into the existing user Menu.Dropdown. The smart wrapper owns the persist
 * mutation + session refresh; this half is props in, onSelect out.
 */
export const ExperienceModeMenuView = ({ current, onSelect }: IProps): React.JSX.Element => {
  const check = (mode: TExperienceMode): React.ReactNode => (current === mode ? <IconCheck size={14} /> : null)

  return (
    <Menu.Sub>
      <Menu.Sub.Target>
        <Menu.Sub.Item leftSection={<IconAdjustments size={14} />} data-testid="experience-mode-menu">
          <Trans>Default for new meetings</Trans>
        </Menu.Sub.Item>
      </Menu.Sub.Target>
      <Menu.Sub.Dropdown className={classes.dropdown}>
        <Menu.Label className={`lex-eyebrow ${classes.eyebrow}`}>
          <Trans>Default for meetings you start from now on</Trans>
        </Menu.Label>
        <Menu.Item
          closeMenuOnClick={false}
          classNames={{ item: classes.item }}
          onClick={() => onSelect("full")}
          rightSection={check("full")}
          data-testid="experience-mode-full"
        >
          <span className={classes.option}>
            <span className={classes.optionTitle}>
              <Trans>Full</Trans>
            </span>
            <span className={classes.optionDescription}>
              <Trans>Summary, decisions, action items, reports, translations.</Trans>
            </span>
          </span>
        </Menu.Item>
        <Menu.Item
          closeMenuOnClick={false}
          classNames={{ item: classes.item }}
          onClick={() => onSelect("lite")}
          rightSection={check("lite")}
          data-testid="experience-mode-lite"
        >
          <span className={classes.option}>
            <span className={classes.optionTitle}>
              <Trans>Lite</Trans>
            </span>
            <span className={classes.optionDescription}>
              <Trans>Record, speakers, transcript, export. No summary.</Trans>
            </span>
          </span>
        </Menu.Item>
        <Menu.Label className={classes.footer}>
          <Trans>Applies to meetings you start from now on. Earlier meetings keep what they have.</Trans>
        </Menu.Label>
      </Menu.Sub.Dropdown>
    </Menu.Sub>
  )
}
